module.exports = __webpack_public_path__ + "assets/pause.png?b4ce1a1dd0e9032bb9d1759f24bdf9ea";